import React, { Component } from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
  OutlinedInput,
} from '@material-ui/core'
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'
import { connect } from 'react-redux'
import { formatMessage } from 'lib/intl'
import ProfileHelper from 'helpers/profile'
import { getTimeFormatMaterial } from 'helpers/dates'
import messages from '../translate'

class StepPlanning extends Component {
  constructor(props) {
    super(props)
    const { startDateTime, endDateTime, isPlanned } = props
    const repeatUntil = startDateTime.clone().add(3, 'months')
    const repeatUntilMin = startDateTime.clone()
    const repeatUntilMax = startDateTime.clone().add(6, 'months')

    this.state = {
      startDateTime,
      endDateTime,
      repeatFrequency: 'never',
      repeatUntil,
      repeatUntilMin,
      repeatUntilMax,
      isPlanned,
      jobsCount: 1,
      form: isPlanned
        ? {
            start_date_time: startDateTime.format('YYYY-MM-DD HH:mm:ss'),
            end_date_time: endDateTime.format('YYYY-MM-DD HH:mm:ss'),
          }
        : {},
      repeatOptions: [
        { id: 'never', name: formatMessage(messages.never) },
        { id: 'daily', name: formatMessage(messages.daily) },
        { id: 'weekly', name: formatMessage(messages.weekly) },
        { id: 'biweekly', name: formatMessage(messages.biweekly) },
        { id: 'monthly', name: formatMessage(messages.monthly) },
      ],
    }
    this.classes = {
      formSiteControl: {
        root: 'sf-form-control sf-form-site-control',
      },
    }
    this.setForm({}, 1)
  }

  applyTimezone = (value, keepDate = false) => {
    const { site, licensee } = this.props
    const timezone = site?.timezone || licensee?.timezone

    return timezone ? value.tz(timezone, keepDate) : value
  }

  getCountJobs = (value, startDateTime, endDateTime) => {
    const ranges = {
      daily: ['days', 1],
      weekly: ['weeks', 1],
      biweekly: ['weeks', 2],
      monthly: ['months', 1],
    }
    let jobsCount = 1

    if (Object.prototype.hasOwnProperty.call(ranges, value)) {
      const [period, factor] = ranges[value]
      jobsCount =
        Math.floor(endDateTime.diff(startDateTime, period) / factor) + 1
    }

    return jobsCount
  }

  onPlanedChange = () => {
    const {
      isPlanned,
      startDateTime,
      endDateTime,
      repeatFrequency,
      repeatUntil,
    } = this.state
    const nextState = {
      isPlanned: !isPlanned,
      jobsCount: 1,
      form: {},
    }

    if (nextState.isPlanned) {
      nextState.form = {
        start_date_time: startDateTime.format('YYYY-MM-DD HH:mm:ss'),
        end_date_time: endDateTime.format('YYYY-MM-DD HH:mm:ss'),
      }

      if (repeatFrequency !== 'never') {
        nextState.jobsCount = this.getCountJobs(
          repeatFrequency,
          startDateTime,
          repeatUntil,
        )
        nextState.form.repeat_frequency = repeatFrequency
        nextState.form.repeat_until = repeatUntil
      }
    }

    this.setState(nextState, this.setForm)
  }

  onDateTimeChange = (key, value) => {
    const {
      isPlanned,
      repeatUntil,
      form,
      startDateTime,
      endDateTime,
    } = this.state
    const { applyTimezone } = this

    if (!isPlanned) {
      return
    }

    let nextStartDateTime = startDateTime
    let nextEndDateTime = endDateTime
    const newDate = applyTimezone(moment(value), true)

    if (key === 'startDateTime') {
      nextStartDateTime = newDate

      if (!endDateTime.isAfter(nextStartDateTime)) {
        nextEndDateTime = newDate.clone().add(1, 'minute')
      }
    } else if (newDate.isAfter(nextStartDateTime)) {
      nextEndDateTime = newDate
    }

    const nextState = {
      startDateTime: nextStartDateTime,
      endDateTime: nextEndDateTime,
      repeatUntilMin: nextStartDateTime.clone(),
      repeatUntilMax: nextStartDateTime.clone().add(6, 'months'),
      form: {
        ...form,
        start_date_time: nextStartDateTime.format('YYYY-MM-DD HH:mm:ss'),
        end_date_time: nextEndDateTime.format('YYYY-MM-DD HH:mm:ss'),
      },
    }

    if (
      !repeatUntil.isBetween(nextState.repeatUntilMin, nextState.repeatUntilMax)
    ) {
      nextState.repeatUntil = nextState.repeatUntilMax.clone()
    }

    this.setState(nextState, this.setForm)
  }

  onRepeatChange = ({ target: { value } }) => {
    const {
      startDateTime,
      repeatUntil,
      form: { start_date_time, end_date_time },
    } = this.state
    const nextForm = {
      start_date_time,
      end_date_time,
    }

    if (value !== 'never') {
      nextForm.repeat_frequency = value
      nextForm.repeat_until = repeatUntil.format('YYYY-MM-DD')
    }

    this.setState(
      {
        jobsCount: this.getCountJobs(value, startDateTime, repeatUntil),
        repeatFrequency: value,
        form: nextForm,
      },
      this.setForm,
    )
  }

  onRepeatUntilChange = date => {
    const { startDateTime, repeatFrequency, form, repeatUntil } = this.state
    const nextRepeatUntil = moment(date)

    if (nextRepeatUntil.isSame(repeatUntil)) {
      return
    }

    this.setState(
      {
        repeatUntil: nextRepeatUntil,
        jobsCount: this.getCountJobs(
          repeatFrequency,
          startDateTime,
          nextRepeatUntil,
        ),
        form: {
          ...form,
          repeat_until: nextRepeatUntil.format('YYYY-MM-DD'),
        },
      },
      this.setForm,
    )
  }

  setForm = () => {
    const { form, jobsCount } = this.state

    this.props.onSetForm(form, jobsCount)
  }

  render() {
    const { formSiteControl } = this.classes
    const {
      isPlanned,
      repeatFrequency,
      repeatUntil,
      repeatUntilMin,
      repeatUntilMax,
      repeatOptions,
      startDateTime,
      endDateTime,
    } = this.state
    const {
      licensee: { usaDateFormat, usaTimeFormat },
    } = this.props
    const timeFormat = getTimeFormatMaterial(usaTimeFormat)
    const dateTimeFormat = `${
      usaDateFormat ? 'MM-dd-yyyy' : 'dd-MM-yyyy'
    } ${timeFormat}`

    const locale = ProfileHelper.getCurrentLocale()

    return (
      <div className="step-planed">
        <FormControl fullWidth variant="outlined" classes={formSiteControl}>
          <FormControlLabel
            label={formatMessage(messages.planForSpecificDates)}
            control={
              <Checkbox
                href={null}
                color="primary"
                checked={isPlanned}
                onChange={this.onPlanedChange}
              />
            }
          />
        </FormControl>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
          <DateTimePicker
            label={formatMessage(messages.startDateAndTime)}
            autoOk
            fullWidth
            allowKeyboardControl={false}
            disabled={!isPlanned}
            format={dateTimeFormat}
            value={startDateTime.format('YYYY-MM-DD HH:mm:ss')}
            onChange={value => {
              this.onDateTimeChange('startDateTime', value)
            }}
            className="date-time-picker"
            minDate={this.applyTimezone(moment())}
            ampm={usaTimeFormat}
          />
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
          <DateTimePicker
            label={formatMessage(messages.endDateAndTime)}
            autoOk
            fullWidth
            allowKeyboardControl={false}
            disabled={!isPlanned}
            format={dateTimeFormat}
            value={endDateTime.format('YYYY-MM-DD HH:mm:ss')}
            onChange={value => {
              this.onDateTimeChange('endDateTime', value)
            }}
            className="date-time-picker"
            minDate={startDateTime.format('YYYY-MM-DD HH:mm:ss')}
            ampm={usaTimeFormat}
          />
        </MuiPickersUtilsProvider>
        <FormControl fullWidth variant="outlined">
          <InputLabel htmlFor="outlined-age-simple">
            {formatMessage(messages.repeat)}
          </InputLabel>
          <Select
            disabled={!isPlanned}
            value={repeatFrequency}
            onChange={this.onRepeatChange}
            input={<OutlinedInput labelWidth={90} id="outlined-age-simple" />}>
            {repeatOptions.map(({ id, name }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
          <DatePicker
            autoOk
            fullWidth
            disablePast
            disableToolbar
            disabled={!isPlanned || repeatFrequency === 'never'}
            variant="inline"
            format={usaDateFormat ? 'MM-dd-yyyy' : 'dd-MM-yyyy'}
            id="date-picker-inline"
            label={formatMessage(messages.repeatUntil)}
            minDate={repeatUntilMin}
            maxDate={repeatUntilMax}
            value={repeatUntil}
            inputVariant="outlined"
            onChange={this.onRepeatUntilChange}
            ampm={usaTimeFormat}
          />
        </MuiPickersUtilsProvider>
      </div>
    )
  }
}

export default connect(state => ({
  licensee: state.getIn(['profile', 'profile', 'licensee']),
  site: state.getIn(['profile', 'profile', 'site']),
}))(StepPlanning)
